import { useCallback, useMemo, useState, type ReactNode } from 'react'
import {
  ShellOverlayMetricsContext,
  useVisualViewportKeyboardInset,
} from './shellOverlayMetrics'

export function ShellOverlayMetricsProvider({ children }: { children: ReactNode }) {
  const [bannerHeightPx, setBannerHeightPxState] = useState(0)
  const keyboardInsetPx = useVisualViewportKeyboardInset()
  const setBannerHeightPx = useCallback((px: number) => {
    const next = Math.max(0, Math.round(px))
    setBannerHeightPxState((prev) => (prev === next ? prev : next))
  }, [])
  const value = useMemo(
    () => ({ bannerHeightPx, keyboardInsetPx, setBannerHeightPx }),
    [bannerHeightPx, keyboardInsetPx, setBannerHeightPx],
  )

  return (
    <ShellOverlayMetricsContext.Provider value={value}>{children}</ShellOverlayMetricsContext.Provider>
  )
}

export default ShellOverlayMetricsProvider
